import ButtonSmall from './ButtonSmall.view';
export default ButtonSmall;
